
    $(document).ready(function(){
        $("#chcbox,#chcbox2").click(function(){
            if ( $('#chcbox').is(':checked') && $('#chcbox2').is(':checked')){

              	$('#sendbtn').css("opacity","1");
              	$('#sendbtn').css("pointer-events","auto");
              	$('#sendbtn').css("cursor","pointer");
            }
            else
            {
                
              	$('#sendbtn').css("opacity",".2");
              	$('#sendbtn').css("pointer-events","none");
              	$('#sendbtn').css("cursor","not-allowed");
            }
        });
    });

	// $(document).ready(function(){
       //  const altSatiraGec = document.querySelectorAll(strong);
	// 	altSatiraGec.replace('-', </br>);
   //  });

	
	